module.exports = __webpack_public_path__ + "img/iconPayment.9b20dfd4.png";